import React, { useState, lazy } from 'react';
import { Menu, X, Phone } from 'lucide-react';
export function Navigation() {
  const [isOpen, setIsOpen] = useState(false);
  const scrollToSection = (e: React.MouseEvent<HTMLAnchorElement>, sectionId: string) => {
    // If we are not on the home page, let the default anchor link behavior work
    if (window.location.pathname !== '/') {
      return;
    }
    e.preventDefault();
    const element = document.getElementById(sectionId);
    if (element) {
      // Use native scrollIntoView so the browser handles dynamic layout
      // shifts (e.g. lazy-loaded images) and respects scroll-padding-top
      element.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
      window.history.pushState(null, '', `#${sectionId}`);
      setIsOpen(false);
    }
  };
  const scrollToTop = (e: React.MouseEvent) => {
    if (window.location.pathname !== '/') {
      return;
    }
    e.preventDefault();
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
    window.history.pushState(null, '', window.location.pathname);
  };
  return <div className="fixed top-0 left-0 right-0 z-50" data-id="element-235" data-mp="hgrfcexbngfz">
      {/* Promo Bar */}
      <a href="/#contact" style={{
      backgroundColor: '#FFE81A'
    }} className="block w-full text-black text-center py-1.5 px-4 text-sm md:text-base font-black uppercase tracking-wide hover:brightness-110 transition-all cursor-pointer" data-id="element-236" data-mp="mgdskod5gwos">
        🔥 Limited Time Only! <span className="text-red-700" style={{
        fontSize: "20px",
        color: "#C92121"
      }} data-id="element-237" data-mp="webf97fd2lfa">$50 OFF</span>{' '}
        Listed Price of Full Details — Call Now!
      </a>

      <nav className="bg-black/95 backdrop-blur-sm border-b border-zinc-900" aria-label="Main navigation" data-id="element-238" data-mp="156ltcztdnb1t">
        <div className="max-w-7xl mx-auto px-4" data-id="element-239" data-mp="1a4x0h2saf7gc">
          <div className="flex items-center justify-between h-16" data-id="element-240" data-mp="1a7t1izzfmc90">
            {/* Logo */}
            <a href="/" onClick={scrollToTop} className="text-xl font-black uppercase tracking-tight" aria-label="Mike's Pro Detail - Home" data-id="element-241" data-mp="1f3895a6ujbwz">
              <span className="text-white" data-id="element-242" data-mp="uf7esg0k9efr">Mike's</span>{' '}
              <span className="text-red-600" data-id="element-243" data-mp="udntuc3ymf7n">Pro Detail</span>
            </a>

            {/* Desktop Navigation */}
            <div className="hidden md:flex items-center gap-6" data-id="element-244" data-mp="145jwm0gzqti7">
              <a href="/#services" onClick={e => scrollToSection(e, 'services')} className="text-gray-300 hover:text-yellow-400 font-bold uppercase text-base tracking-wider transition-colors" data-id="element-245" data-mp="147wlyyp2w65a">
                Services
              </a>
              <a href="/#about" onClick={e => scrollToSection(e, 'about')} className="text-gray-300 hover:text-yellow-400 font-bold uppercase text-base tracking-wider transition-colors" data-id="element-246" data-mp="187nhffpjvag5">
                About
              </a>
              <a href="/#gallery" onClick={e => scrollToSection(e, 'gallery')} className="text-gray-300 hover:text-yellow-400 font-bold uppercase text-base tracking-wider transition-colors" data-id="element-247" data-mp="1i6mk8hnmwbv8">
                Gallery
              </a>
              <a href="/#reviews" onClick={e => scrollToSection(e, 'reviews')} className="text-gray-300 hover:text-yellow-400 font-bold uppercase text-base tracking-wider transition-colors" data-id="element-248" data-mp="3jz0yn6qyyy6w">
                Reviews
              </a>
              <a href="/#faq" onClick={e => scrollToSection(e, 'faq')} className="text-gray-300 hover:text-yellow-400 font-bold uppercase text-base tracking-wider transition-colors" data-id="element-249" data-mp="1ppdmgj7xwbxl">
                FAQ
              </a>
              <a href="/#contact-form" onClick={e => scrollToSection(e, 'contact-form')} className="text-gray-300 hover:text-yellow-400 font-bold uppercase text-base tracking-wider transition-colors" data-id="element-250" data-mp="1go608zip71jv">
                Contact Us
              </a>
              <a href="tel:8183819905" className="flex items-center gap-2 px-5 py-2 bg-red-600 hover:bg-red-700 text-white font-bold rounded transition-colors" aria-label="Call Mike's Pro Detail" data-id="element-251" data-mp="16sci90m7mfup">
                <Phone className="w-4 h-4" data-id="element-252" data-mp="3126c9oh66qb0" />
                <span className="text-base tracking-tight" data-id="element-253" data-mp="363vnb44e73z3">(818) 381-9905</span>
              </a>
            </div>

            {/* Mobile Menu Button */}
            <button onClick={() => setIsOpen(!isOpen)} className="md:hidden text-white p-2" aria-label="Toggle menu" data-id="element-254" data-mp="15z07pme4mw0k">
              {isOpen ? <X className="w-6 h-6" data-id="element-255" data-mp="x063paygv3cz" /> : <Menu className="w-6 h-6" data-id="element-256" data-mp="wzd5iydkpm6g" />}
            </button>
          </div>

          {/* Mobile Navigation */}
          {isOpen && <div className="md:hidden py-4 border-t border-zinc-900" data-id="element-257" data-mp="s0tlj3ijikgq">
              <div className="flex flex-col gap-4" data-id="element-258" data-mp="n3a5by2a7xm5">
                <a href="/#services" onClick={e => scrollToSection(e, 'services')} className="text-gray-300 hover:text-yellow-400 font-bold uppercase text-base tracking-wider transition-colors text-left" data-id="element-259" data-mp="n4352f2tpmus">
                  Services
                </a>
                <a href="/#about" onClick={e => scrollToSection(e, 'about')} className="text-gray-300 hover:text-yellow-400 font-bold uppercase text-base tracking-wider transition-colors text-left" data-id="element-260" data-mp="9bv92pjd5zx5">
                  About
                </a>
                <a href="/#gallery" onClick={e => scrollToSection(e, 'gallery')} className="text-gray-300 hover:text-yellow-400 font-bold uppercase text-base tracking-wider transition-colors text-left" data-id="element-261" data-mp="3vkecrc4ymmcw">
                  Gallery
                </a>
                <a href="/#reviews" onClick={e => scrollToSection(e, 'reviews')} className="text-gray-300 hover:text-yellow-400 font-bold uppercase text-base tracking-wider transition-colors text-left" data-id="element-262" data-mp="2kz8k1vkcfdxt">
                  Reviews
                </a>
                <a href="/#faq" onClick={e => scrollToSection(e, 'faq')} className="text-gray-300 hover:text-yellow-400 font-bold uppercase text-base tracking-wider transition-colors text-left" data-id="element-263" data-mp="1s7ou7st8r1mu">
                  FAQ
                </a>
                <a href="/#contact-form" onClick={e => scrollToSection(e, 'contact-form')} className="text-gray-300 hover:text-yellow-400 font-bold uppercase text-base tracking-wider transition-colors text-left" data-id="element-264" data-mp="261g26wrbqdgg">
                  Contact Us
                </a>
                <a href="tel:8183819905" className="flex items-center justify-center gap-2 px-5 py-3 bg-red-600 hover:bg-red-700 text-white font-bold rounded transition-colors" aria-label="Call Mike's Pro Detail" data-id="element-265" data-mp="1di95eid9t69s">
                  <Phone className="w-4 h-4" data-id="element-266" data-mp="2qlcieiz513xx" />
                  <span className="text-base tracking-tight" data-id="element-267" data-mp="2qk1800b6sxxu">
                    (818) 381-9905
                  </span>
                </a>
              </div>
            </div>}
        </div>
      </nav>
    </div>;
}